<app-mobile-header-secondary title="{{ 'settings.accessApi' | translate }}"></app-mobile-header-secondary>

<!--<div class="mobile mobile__page-in-construction">-->
<!--  <div class="mobile__message mobile__message&#45;&#45;red"><b>Disponível na versão desktop.</b></div>-->
<!--</div>-->

<div class="group">
  <div class="group__title">{{ 'settings.documentations' | translate }}</div>

  <div class="group__options">
    <a href="https://docs.autentique.com.br/" class="group__option" target="_blank">
      <div class="group__option-icon"><i class="fal fa-external-link"></i></div>
      <div class="group__option-name">{{ 'settings.documentationsApi' | translate }}</div>
    </a>
  </div>
</div>

<div class="group">
  <div class="group__title">{{ 'settings.tokensApi' | translate }}</div>

  <div class="group__options">
    <button type="button" class="group__option" (click)="createApiToken()" [disabled]="isLoading">
      <div class="group__option-icon"><i class="fal fa-external-link"></i></div>
      <div class="group__option-name">{{ 'settings.generateNewTokenApi' | translate }}</div>
    </button>
  </div>
</div>

<div class="group">
  <div class="group__options">
    <ng-container *ngFor="let token of apiTokens">
      <div class="group__option group__option--without-arrow" [ngxClipboard]="tokenInputElement" (click)="copyApiLink()">
        <div class="group__option-icon"><i class="fal fa-copy"></i></div>
        <div class="group__option-small group__option-small--alternative" style="overflow: hidden; text-overflow: ellipsis">{{ token.access_token }}</div>
        <input type="text" class="d-none" [value]="token.access_token" readonly #tokenInputElement />
      </div>
    </ng-container>
  </div>
</div>

@if (oauthTokens.length > 0) {
  <div class="group">
    <div class="group__title">{{ 'settings.oauthApplications.title' | translate }}</div>
    <div class="configuration-text oauth-applications-description oauth-applications-description--mobile">
      {{ 'settings.oauthApplications.description' | translate }}
    </div>
    <div class="group__options oauth-applications-list oauth-applications-list--mobile">
      @for (token of oauthTokens; track token.id) {
        <div class="oauth-applications-item oauth-applications-item--mobile">
          <div class="oauth-applications-icon" aria-hidden="true">
            <img [src]="token.client_icon_url" [alt]="token.client_name" />
          </div>

          <div class="oauth-applications-main">
            <div class="oauth-applications-heading">
              <span class="oauth-applications-name">{{ token.client_name }}</span>
              @if (isOAuthTokenExpired(token)) {
                <span class="oauth-applications-status">
                  {{ 'settings.oauthApplications.expired' | translate }}
                </span>
              }
            </div>
            <span class="oauth-applications-description">{{ getOAuthTokenPermissionsDescription(token) }}</span>
          </div>

          <div class="oauth-applications-menu" ngbDropdown placement="bottom-right" container="body">
            <button type="button" class="oauth-applications-menu-button" ngbDropdownToggle>
              <i class="fa-regular fa-ellipsis-vertical"></i>
            </button>

            <div ngbDropdownMenu>
              <button type="button" class="text-danger" ngbDropdownItem [disabled]="isLoading" (click)="revokeOAuthToken(token.id)">
                <i class="fa-regular fa-trash icon text-danger"></i>
                {{ 'settings.oauthApplications.revokeAccess' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
    @if (!isLoadingOAuthTokens && !oauthTokensIsLastPage) {
      <div class="text-center mt-3">
        <button type="button" class="btn btn-link" (click)="loadOAuthTokens({ page: oauthTokensPageNumber + 1 })">{{ 'button.loadMore' | translate }}</button>
      </div>
    }
  </div>
}

<div class="group">
  <div class="group__title">{{ 'settings.sandboxOptions' | translate }}</div>
  <div class="group__options">
    <label class="group__option group__option--without-arrow mb-0">
      <app-switch [(ngModel)]="appService.showSandbox" class="mr-2 ml-3"></app-switch>
      <div class="group__option-name">{{ 'settings.showAllSandboxDocuments' | translate }}</div>
    </label>
  </div>
</div>

<article class="configuration-item d-none d-lg-block">
  <div class="configuration-container">
    <div class="configuration-content">
      <p class="configuration-title">{{ 'settings.tokensApi' | translate }}</p>
      <div class="configuration-text" [innerHTML]="'settings.apiTokensDescription' | translate"></div>
    </div>
    <div class="configuration-generate">
      <button type="button" class="btn-M btn-text icon-start" (click)="createApiToken()" [disabled]="isLoading"><i class="far fa-key"></i>{{ 'settings.generateNewToken' | translate }}</button>
    </div>
  </div>
  @if (urlParamsService.params.documentationLink && !enterpriseService.hideForEnterprise()) {
    <a href="https://docs.autentique.com.br/" class="configuration-documentation" target="_blank">
      <i class="fal fa-external-link"></i>
      {{ 'button.accessDocumentation' | translate }}
    </a>
  }
  <div class="configuration-container mb-4">
    <div class="configuration-switches-item">
      <app-switch [(ngModel)]="appService.showSandbox"></app-switch>
      <span class="configuration-switches-name">{{ 'settings.showAllSandboxDocuments' | translate }}</span>
    </div>
  </div>
  <div class="configuration-container">
    <div class="configuration-content">
      <p class="configuration-title mt-4 mb-0">{{ 'settings.activeTokens' | translate }}</p>

      <div class="configuration-sub_item" *ngFor="let token of apiTokens">
        <div class="configuration-info">
          <span class="configuration-info-date" title="{{ token.created_at | ldate: 'long' }}"> {{ 'settings.createdAt' | translate }} {{ token.created_at | dateTime: 'mediumDate' }} </span>
          <button type="button" class="btn btn-link configuration-info-rm" (click)="deleteApiToken(token.access_token)" [disabled]="isLoading" *ngIf="!token.parent_organization_id">
            <i class="fa-regular fa-trash"></i>
            {{ 'settings.revokeToken' | translate }}
          </button>
          <span class="configuration-info-owner" *ngIf="token.parent_organization_name">
            <i class="fa-regular fa-lock"></i>
            {{ 'settings.managedBy' | translate }} <strong>{{ token.parent_organization_name }}</strong>
          </span>
        </div>
        <div class="configuration-value">
          <input type="text" class="configuration-value-show" [value]="token.access_token" readonly #tokenInputElement />
          <div class="configuration-value-copy" (click)="copyApiLink()" [ngxClipboard]="tokenInputElement"></div>
        </div>
      </div>
    </div>
  </div>

  @if (oauthTokens.length > 0) {
    <div class="oauth-applications">
      <p class="configuration-title mb-1">{{ 'settings.oauthApplications.title' | translate }}</p>
      <div class="configuration-text">{{ 'settings.oauthApplications.description' | translate }}</div>

      <div class="oauth-applications-list">
        @for (token of oauthTokens; track token.id) {
          <div class="oauth-applications-item">
            <div class="oauth-applications-icon" aria-hidden="true">
              <img [src]="token.client_icon_url" [alt]="token.client_name" />
            </div>

            <div class="oauth-applications-main">
              <div class="oauth-applications-heading">
                <span class="oauth-applications-name">{{ token.client_name }}</span>
                @if (isOAuthTokenExpired(token)) {
                  <span class="oauth-applications-status">
                    {{ 'settings.oauthApplications.expired' | translate }}
                  </span>
                }
              </div>

              <span class="oauth-applications-description">{{ getOAuthTokenPermissionsDescription(token) }}</span>
            </div>

            <div class="oauth-applications-menu" ngbDropdown placement="bottom-right" container="body">
              <button type="button" class="oauth-applications-menu-button" ngbDropdownToggle>
                <i class="fa-regular fa-ellipsis-vertical"></i>
              </button>

              <div ngbDropdownMenu>
                <button type="button" class="text-danger" ngbDropdownItem [disabled]="isLoading" (click)="revokeOAuthToken(token.id)">
                  <i class="fa-regular fa-trash icon text-danger"></i>
                  {{ 'settings.oauthApplications.revokeAccess' | translate }}
                </button>
              </div>
            </div>
          </div>
        }
      </div>

      @if (!isLoadingOAuthTokens && !oauthTokensIsLastPage) {
        <div class="text-center mt-3">
          <button type="button" class="btn btn-link" (click)="loadOAuthTokens({ page: oauthTokensPageNumber + 1 })">{{ 'button.loadMore' | translate }}</button>
        </div>
      }
    </div>
  }
</article>
